interface SelectIconSurveyProps extends React.ComponentProps<'div'> {
  submit: () => void
}

export default function SelectIconSurvey ({ submit, ...rest }: SelectIconSurveyProps) {

  return(
    <div {...rest}>
      
    </div>
  )
}